module.exports = __webpack_public_path__ + "static/media/vail-12.f975dd3b.jpg";